import React, { useState } from 'react';

import styled from '@emotion/styled';

import { ExternalLinkButton } from '../../../../components/Button/ExternalLinkButton';
import { FormSubmitButton } from '../../../../components/Button/FormSubmitButton';
import { ReadOnlyBlurTextField } from '../../../../components/FormCom/ReadOnlyBlurTextField';
import { Modal } from '../../../../components/Modal/Modal';
import GenerateApiKeyModal from '../../../../components/Modal/ModalActions/GenerateApiKeyModal/GenerateApiKeyModal';
import useGetNewApiKeys from '../../../../hooks/dashboard/configuration/useGetNewApiKeys';
import { useAppSelector } from '../../../../redux/store';

const ApiKeyGenerationForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [showKey, setShowKey] = useState(false);
  const { getNewApiKeys, newPlainKeyValue, loading } = useGetNewApiKeys();
  const { apiKeysData } = useAppSelector((state) => state.apiKeysData);

  const generateNewApiKey = () => {
    getNewApiKeys(() => {});
    setShowModal(true);
  };

  let apiKeyIdValue = apiKeysData?.keyId ?? '';

  if (apiKeysData?.keyId) {
    apiKeyIdValue = `***********************.${apiKeyIdValue}`;
  }

  return (
    <Container>
      <FormHeader>
        <FormHeaderLabel>API Keys</FormHeaderLabel>
        <FormHeaderDescription>
          Manage API Keys for this instance. Keep your key safe, do not share
          them with anyone.
        </FormHeaderDescription>
      </FormHeader>

      <FormArea>
        <ShowKeyArea>
          <ReadOnlyBlurTextField
            id='apiKey'
            value={apiKeyIdValue}
            showKey={showKey}
            setShowKey={setShowKey}
          />
        </ShowKeyArea>

        <ButtonArea>
          <FormSubmitButton
            onClick={generateNewApiKey}
            btnType='button'
            loading={loading}
          >
            Generate New Keys
          </FormSubmitButton>
          <ExternalLinkButton
            href='https://documenter.getpostman.com/view/56055378/2sBY4QsKu7'
            className='borderless'
          >
            <SpanText className='web'>View Documentation</SpanText>
            <SpanText className='mobile'>View Docs</SpanText>
          </ExternalLinkButton>
        </ButtonArea>
      </FormArea>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <GenerateApiKeyModal
          loading={loading}
          newlyGeneratedApiKey={newPlainKeyValue ?? ''}
        />
      </Modal>
    </Container>
  );
};

export default ApiKeyGenerationForm;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 29px;
  padding-bottom: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const FormHeader = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

const ShowKeyArea = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr auto;
`;

const FormHeaderLabel = styled.div`
  display: flex;
  font-size: 22px;
  line-height: 22px;
  font-weight: 600;
`;

const FormHeaderDescription = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 20px;
`;

const FormArea = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 5px;
  padding: 32px;
  max-width: 826px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #fff;

  @media (max-width: 884px) {
    /* border: 1px solid red; */
    padding: 20px;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  gap: 12px;
`;

const SpanText = styled.span`
  &.web {
    display: flex;

    @media (max-width: 884px) {
      display: none;
    }
  }

  &.mobile {
    display: none;

    @media (max-width: 884px) {
      display: flex;
    }
  }
`;
